<template>
  <div>
    <date-filter-template dateType="Start" :values="values" :errors="errors"/>
    <span class="text-muted">The date from and/or to the date when the event starts.</span>
  </div>
</template>
<script>
  import dateFilterTemplate from '@/components/wdc/filters/date-filter-template'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'

  export default {
    components: {
      dateFilterTemplate
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'startDateFilter',
    data () {
      return {
        options: FILTER_OPTIONS,
        comparisonText: 'Comparison'
      }
    }
  }
</script>
<style>
</style>
